/**
 * Fills the `{{key}}` placeholders of a translation with the given values, in one pass. Values are inserted exactly as
 * they are: with a plain string replacement, `String.replace` would read `$&`, `$'` and the like in user-entered text
 * (names, emails) as replacement patterns. A placeholder without a value is left as it is.
 */
export const formatTranslation = (template: string, values: Record<string, string | number>): string =>
  template.replace(/{{(\w+)}}/g, (placeholder, key: string) =>
    Object.hasOwn(values, key) ? String(values[key]) : placeholder
  );
